// extracted by mini-css-extract-plugin
module.exports = {"root":"Layout_root__1Odij","wrap":"Layout_wrap__2N_2f","content":"Layout_content__1rQBK"};